<template>
  <div class="order-list-wrapper">
    <!-- 遍历所有有效订单 -->
    <template>
      <div class="">
        <section class="about-item-area">
          <div class="container">
            <div class="bg-white" v-loading="isLoading">
              <div class="divider mt-5 mb-15"></div>
              <EventInfo @event-ready="onEventReady" />
              <el-divider></el-divider>

              <template v-if="event && event.closetime > Math.floor(Date.now() / 1000)">
                <!-- 已有订单：展示订单与电子凭证 -->
                <div v-if="validOrders.length > 0" class="registered-wrapper">
                  <!-- 顶部操作栏 -->
                  <div class="order-actions-bar">
                    <div class="order-summary">
                      <span class="order-count">{{ $t('order.summary', { count: validOrders.length }) }}</span>
                      <span class="order-total-badges">{{ $t('order.badges', { count: totalBadgesCount }) }}</span>
                    </div>
                    <el-button type="primary" size="medium" @click="goToForm">
                      <i class="el-icon-plus"></i> {{ $t('order.registerNow') }}
                    </el-button>
                  </div>

                  <!-- 遍历所有有效订单 -->
                  <div 
                    v-for="(order, orderIndex) in validOrders" 
                    :key="order.id || orderIndex"
                    class="order-section"
                  >
                    <el-row :gutter="40">
                      <!-- 左侧：订单信息 -->
                      <el-col :span="8" :xs="24">
                        <div class="section-block order-info-card">
                          <div class="order-card-header">
                            <div>
                              <h4 class="section-title">{{ $t('content.order.title') }}</h4>
                              <div class="order-status-row">
                                <template v-if="order.refundstatus > 0">
                                  <el-tag 
                                    v-if="order.refundstatus == 100" 
                                    color="#67c23a" 
                                    size="small"
                                  >{{ $t('content.order.status.refunded') }}</el-tag>

                                  <el-tag 
                                    v-else-if="order.refundstatus == 50" 
                                    color="#e6a23c" 
                                    size="small"
                                  >{{ $t('content.order.status.refund_pending') }}</el-tag>

                                  <el-tag 
                                    v-else-if="order.refundstatus == 1" 
                                    color="#909399" 
                                    size="small"
                                  >{{ $t('content.order.status.refund_apply') }}</el-tag>
                                </template>

                                <template v-else>
                                  <el-tag 
                                    v-if="order.status == -20
                                          && (!order.paysource || order.paysource == 0 || order.paysource == 2 || order.paysource == 3) 
                                          && order.expiretime 
                                          && order.expiretime < Date.now() / 1000"     
                                    color="#e6a23c"
                                    size="small"
                                  >{{ $t('content.order.status.expired') }}</el-tag>

                                  <el-tag 
                                    v-else-if="order.status == -50"     
                                    color="#f56c6c"
                                    size="small"
                                  >{{ $t('content.order.status.cancel') }}</el-tag>

                                  <el-tag 
                                    v-else-if="order.status == -10"     
                                    color="#909399"
                                    size="small"
                                  >{{ $t('content.order.status.void') }}</el-tag>

                                  <el-tag 
                                    v-else-if="order.status == -100"     
                                    color="#c0c4cc"
                                    size="small"
                                  >{{ $t('content.order.status.delete') }}</el-tag>
                                  
                                  <el-tag 
                                    v-else-if="order.paystatus == 99"   
                                    color="#67c23a"
                                    size="small"
                                  >{{ $t('content.order.status.free') }}</el-tag>

                                  <el-tag 
                                    v-else-if="order.paystatus == 100"  
                                    color="#67c23a"
                                    size="small"
                                  >{{ $t('content.order.status.completed') }}</el-tag>

                                  <el-tag 
                                    v-else-if="order.paystatus == 50"  
                                    color="#409eff"
                                    size="small"
                                  >{{ $t('content.order.status.bank_pending') }}</el-tag>

                                  <el-tag 
                                    v-else                             
                                    color="#f56c6c"
                                    size="small"
                                  >{{ $t('content.order.status.pending') }}</el-tag>
                                </template>
                              </div>
                            </div>
                            
                            <template v-if="order.paystatus < 99">
                              <img
                                v-if="order.paystatus == 50"
                                class="order-status-icon"
                                src="~@/assets/icons/paystatus-50.png"
                                alt="待支付"
                              />

                              <img
                                v-else-if="order.status == 0"
                                class="order-status-icon"
                                style="width: 70px;"
                                src="~@/assets/icons/paystatus-0.png"
                                alt="待支付"
                              />

                            </template>
                          
                          </div>
                          
                          <div class="text-row">
                            <div class="text-label">{{ $t('content.order.orderno') }}</div>
                            <div class="text-value">{{ order.id || '-' }}</div>
                          </div>
                          <div class="text-row">
                            <div class="text-label">{{ $t('content.order.subject') }}</div>
                            <div class="text-value">{{ order.subject || '-' }}</div>
                          </div>
                          <div class="text-row">
                            <div class="text-label">{{ $t('content.order.amount') }}</div>
                            <div class="text-value">¥{{ order.amount ? (order.amount / 100).toFixed(2) : '0.00' }}</div>
                          </div>
                          <div class="text-row" v-if="order.paytime">
                            <div class="text-label">{{ $t('content.order.paytime') }}</div>
                            <div class="text-value">{{ formatTimestampToDateTime(order.paytime) }}</div>
                          </div>
                          
                          <div class="pay-action-wrap">
                            <div class="btn-group">
                              <!-- 立即支付：paystatus < 99 且 status >= 0 且 paystatus != 50 -->
                              <el-button 
                                v-if="order.paystatus < 99 && order.status >= 0 && order.paystatus != 50" 
                                type="primary" 
                                size="medium" 
                                @click="showPaymentPanelForOrder(order)"
                              >
                                <i class="el-icon-money"></i> {{ $t('order.button.payNow') }}
                              </el-button>

                              <!-- 取消订单：status == 0 且 paystatus == 0 -->
                              <el-button 
                                v-if="order.status == 0 && order.paystatus == 0" 
                                type="danger" 
                                size="medium" 
                                @click="cancelOrder(order)"
                              >
                                <i class="el-icon-delete"></i> {{ $t('order.button.cancel') }}
                              </el-button>

                              <template v-if="order.refundstatus == 0">
                                <el-button 
                                  v-if="order.paystatus == 100 && 
                                        orderConfig.enableRefund" 
                                  type="warning" 
                                  size="medium" 
                                  @click="applyRefund(order)"
                                >
                                  <i class="el-icon-coin"></i> {{ $t('order.button.applyRefund') }}
                                </el-button>

                                <el-button 
                                  v-if="order.status >= 0 && order.amount > 0 && 
                                        (order.paystatus == 100 || (order.paysource != 2 && order.paysource != 3)) && 
                                        orderConfig.enableInvoice" 
                                  type="success" 
                                  size="medium" 
                                  @click="applyInvoice(order)"
                                >
                                  <i class="el-icon-tickets"></i> {{ $t('order.button.applyInvoice') }}
                                </el-button>
                              </template>

                              <!-- 🔥 查看/编辑问卷回执 -->
                              <el-button 
                                v-if="order.responseid" 
                                type="info" 
                                size="medium" 
                                @click="fetchSurveyResponse(order.responseid)"
                                plain
                              >
                                <i class="el-icon-s-home"></i> {{ $t('order.button.viewSurvey') }}
                              </el-button>
                            </div>
                          </div>
                        </div>
                      </el-col>

                      <!-- 右侧：该订单对应的电子凭证列表 -->
                      <el-col :span="16" :xs="24">
                        <div class="section-block">
                          <h4 class="section-title">
                            {{ $t('content.badge.title') }}
                            <span class="badge-count">({{ getOrderBadges(order.id).length }}{{ $t('content.badge.unit') }})</span>
                          </h4>
                          
                          <div 
                            v-for="(badgeItem, idx) in getOrderBadges(order.id)" 
                            :key="badgeItem.ebadgeid || idx"
                            class="ticket-card"
                            :class="{ 'ticket-pending': badgeItem.status === -10 }"
                          >
                            <div class="ticket-left">
                              <div class="ticket-row-two">
                                <div class="ticket-col">
                                  <div class="ticket-label">{{ $t('register.realname') }}</div>
                                  <div class="ticket-value">{{ badgeItem.realname || '-' }}</div>
                                </div>
                                <div class="ticket-col">
                                  <div class="ticket-label">{{ $t('register.company') }}</div>
                                  <div class="ticket-value">{{ badgeItem.company || '-' }}</div>
                                </div>
                              </div>

                              <div class="ticket-row-two">
                                <div class="ticket-col">
                                  <div class="ticket-label">{{ $t('register.cellphone') }}</div>
                                  <div class="ticket-value">{{ badgeItem.cellphone || '-' }}</div>
                                </div>
                                <div class="ticket-col">
                                  <div class="ticket-label">{{ $t('register.position') }}</div>
                                  <div class="ticket-value">{{ badgeItem.title || '-' }}</div>
                                </div>
                              </div>

                              <div class="ticket-row-two">
                                <div class="ticket-col">
                                  <div class="ticket-label">{{ $t('register.email') }}</div>
                                  <div class="ticket-value">{{ badgeItem.email || '-' }}</div>
                                </div>
                                <!--
                                <div class="ticket-col">
                                  <div class="ticket-label">{{ $t('register.country') }}</div>
                                  <div class="ticket-value">{{ getCountryName(badgeItem.country) }}</div>
                                </div>
                                -->
                              </div>
                            </div>

                            <div class="ticket-divider-notch"></div>

                            <div class="ticket-right">
                              <vue-qrcode 
                                display-value="false"
                                :value="badgeItem.ebadgeid || badgeItem.id" 
                                :color="{ dark: '#000000' }"
                                type="image/png"
                                :size="140"
                                @change="(dataUrl) => handleBadgeQr(badgeItem.ebadgeid || badgeItem.id, dataUrl)"
                              />
                              <img 
                                v-if="badgeQrcodeMap[badgeItem.ebadgeid || badgeItem.id]" 
                                :src="badgeQrcodeMap[badgeItem.ebadgeid || badgeItem.id]" 
                                :alt="badgeItem.realname || '-'"
                                class="ticket-qrcode-img"
                              />
                              <div class="qrcode-caption">{{ $t('content.badge.qr.tip') }}</div>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                    <el-divider v-if="orderIndex < validOrders.length - 1"></el-divider>
                  </div>
                </div>
              </template>

              <template v-else-if="event && event.closetime < Math.floor(Date.now() / 1000)">            
                <el-empty :description="$t('order.eventEnded')"></el-empty>
              </template>

              <!-- 支付弹窗 -->
              <PaymentDialog
                :visible.sync="showPaymentPanel"
                :order-id="orderId"
                :order-subject="orderSubject"
                :order-amount="orderAmount"
                @payment-success="onPaymentSuccess"
                @payment-cancel="onPaymentCancel"
              />

              <!-- 发票申请弹窗 -->
              <InvoiceDialog
                :visible.sync="showInvoiceDialog"
                :order-id="invoiceOrderId"
                :order-data="invoiceOrderData"
                :order-amount="invoiceOrderAmount"
                :event-id="eventid"
                :merchant-id="invoiceMerchantId"
                @success="onInvoiceSuccess"
              />

              <!-- 问卷回执弹窗（可编辑） -->
              <el-dialog
                :title="$t('order.button.viewSurvey')"
                :visible.sync="showSurveyDialog"
                width="60%"
                :close-on-click-modal="false"
                @close="closeSurveyDialog"
              >
                <div v-loading="surveyLoading" style="min-height: 200px;">
                  <!-- 显示问卷内容（可编辑） -->
                  <div v-if="surveyResponse" class="survey-response-content">
                    <div class="survey-items">
                      <div 
                        v-for="(item, index) in surveyQuestions" 
                        :key="item.id || index"
                        class="survey-item"
                      >
                        <div class="survey-question">
                          {{ item.title }}
                          <span v-if="item.required" class="required-star">*</span>
                        </div>
                        <div class="survey-answer">
                          <!-- 单选 radio -->
                          <template v-if="item.type === 'radio'">
                            <el-radio-group
                              v-model="surveyForm[item.id]"
                              @change="(val) => submitRadio(item.id, val, false, '', item.options)"
                            >
                              <el-radio
                                v-for="opt in item.options"
                                :key="opt.value"
                                :label="opt.value"
                              >
                                {{ opt.label }}
                              </el-radio>
                            </el-radio-group>
                          </template>

                          <!-- 文本 text -->
                          <template v-else-if="item.type === 'text'">
                            <el-input
                              v-model="surveyForm[item.id]"
                              :placeholder="getPlaceholder(item)"
                              @blur="submitText(item.id, surveyForm[item.id])"
                            ></el-input>
                          </template>

                          <!-- 日期 date -->
                          <template v-else-if="item.type === 'date'">
                            <el-date-picker
                              v-model="surveyForm[item.id]"
                              type="date"
                              value-format="yyyy-MM-dd"
                              :placeholder="getPlaceholder(item)"
                              style="width:100%"
                              @change="(val) => submitDate(item.id, val)"
                            ></el-date-picker>
                          </template>

                          <!-- 文本域 textarea -->
                          <template v-else-if="item.type === 'textarea'">
                            <el-input
                              v-model="surveyForm[item.id]"
                              type="textarea"
                              :rows="3"
                              :placeholder="getPlaceholder(item)"
                              @blur="submitText(item.id, surveyForm[item.id])"
                            ></el-input>
                          </template>

                          <!-- 数字 number -->
                          <template v-else-if="item.type === 'number'">
                            <el-input-number
                              v-model="surveyForm[item.id]"
                              :min="0"
                              @change="(val) => submitText(item.id, val)"
                            ></el-input-number>
                          </template>
                        </div>
                        <div v-if="item.helpText" class="survey-help">{{ item.helpText }}</div>
                      </div>
                    </div>
                    <div class="survey-footer">
                      <span class="survey-time">提交时间：{{ formatTimestampToDateTime(surveyResponse.createdat) }}</span>
                      <span class="survey-status" :class="surveyResponse.status === 100 ? 'status-submitted' : 'status-draft'">
                        {{ surveyResponse.status === 100 ? '已提交' : '草稿' }}
                      </span>
                    </div>
                    <div class="survey-actions">
                      <el-button type="primary" @click="submitSurvey" :loading="surveySubmitting">
                        保存修改
                      </el-button>
                      <el-button @click="showSurveyDialog = false">关闭</el-button>
                    </div>
                  </div>
                  <div v-else-if="!surveyLoading" class="survey-empty">
                    <el-empty description="暂无问卷回执"></el-empty>
                  </div>
                </div>
              </el-dialog>

            </div>
          </div>
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'
import config from '@/config';
import EventInfo from "@/components/Event/Info.vue";
import countryData from '@/components/Data/country.json';
import PaymentDialog from '@/components/Order/PaymentDialog.vue'
import InvoiceDialog from '@/components/Order/InvoiceDialog.vue'
import { getEventSettings, getEventTicketList } from "@/api/event";
import { getMeOrders, getOrderBadges, putOrderCancel, postOrderRefunds } from '@/api/user';
import { getOrder, postOrder } from '@/api/order';
import { getSurveyResponse, getQuestions, postAnswer, postSurveySubmit } from '@/api/survey';

import profileService from '@/utils/profileService';
import { formatTimestampToDateTime } from '@/utils/dateUtil';
import { eventBus } from '@/utils/eventBus.js';

// 默认字段配置（不包含国籍）
const DEFAULT_FIELDS = [
  { label: '姓名', name: 'realname', required: true, sort: 99 },
  { label: '性别', name: 'gender', required: false, sort: 10, type: 'select', options: { '1': '男', '2': '女' } },
  { label: '手机号', name: 'cellphone', required: true, sort: 98 },
  { label: '单位', name: 'company', required: false, sort: 0 },
  { label: '职务', name: 'position', required: false, sort: 0 },
  { label: '职称', name: 'title', required: false, sort: 0 },
  { label: '电子邮箱', name: 'email', required: false, sort: 0 },
  { label: '部门', name: 'department', required: false, sort: 0 },
  { label: '出生年月', name: 'birthdate', required: false, sort: 0 },
  { label: '证件类型', name: 'idtype', required: false, sort: 0, type: 'select', options: { '身份证': '身份证', '护照': '护照', '军官证': '军官证' } },
  { label: '证件号', name: 'idnumber', required: false, sort: 0 },
  { label: '民族', name: 'ethnicity', required: false, sort: 0 },
  { label: '地址', name: 'address', required: false, sort: 0 },
  { label: '其他备注', name: 'memo', required: false, sort: 0 },
];

export default {
  components: {
    VueQrcode,
    EventInfo,
    PaymentDialog,
    InvoiceDialog
  },
  inject: ['dataWrapper', 'fetchStatus', 'eventFetchStatus'],
  data() {
    return {
      isLoading: true,
      isSubmitting: false,
      eventid: config.EVENTID,
      event: null,
      fields: [],
      // 多个订单
      validOrders: [],
      // 订单对应的 badges 映射
      orderBadgesMap: {},
      badgeQrcodeMap: {},
      // 表单相关
      guests: [],
      ticketList: [],
      selectedTicketId: null,
      ticketCountMap: {},
      countryOptions: countryData,
      ticket: { price: undefined },
      // 支付相关
      showPaymentPanel: false,
      orderId: '',
      orderSubject: '',
      orderAmount: 0,
      ticketFetched: false,
      ticketCache: null,
      currentLocale: localStorage.getItem('locale') || 'zh-cn',
      // 是否已经跳转过
      hasRedirected: false,
      // 订单配置
      orderConfig: {
        enableInvoice: true,
        enableRefund: false
      },
      showInvoiceDialog: false,
      invoiceOrderId: '',
      invoiceOrderData: {},
      invoiceOrderAmount: 0,
      invoiceMerchantId: '',
      // 问卷回执相关
      showSurveyDialog: false,
      surveyLoading: false,
      surveySubmitting: false,
      surveyResponse: null,
      surveyQuestions: [],
      surveyForm: {},
      surveySid: '',
      surveyOrderId: '',
      submittingQids: new Set(),
    };
  },
  computed: {
    userProfile() {
      return profileService.getProfile();
    },
    isEn() {
      const locale = this.$i18n?.locale || localStorage.getItem('locale') || 'zh-cn';
      return locale === 'en' || locale === 'en-US';
    },
    labelWidth() {
      return this.isEn ? '180px' : '100px';
    },
    currentTicketCount() {
      if (!this.selectedTicketId) return 0;
      return this.ticketCountMap[this.selectedTicketId] || 0;
    },
    calcTotalPrice() {
      if (!this.selectedTicketId || !this.ticket) return '0.00';
      const num = this.ticketCountMap[this.selectedTicketId] || 0;
      const price = this.ticket.price / 100;
      return (num * price).toFixed(2);
    },
    totalBadgesCount() {
      let count = 0;
      this.validOrders.forEach(order => {
        const badges = this.orderBadgesMap[order.id] || [];
        count += badges.length;
      });
      return count;
    },
    visibleFields() {
      return this.fields
        .filter(f => f.status === 1 && f.name !== 'country')
        .sort((a, b) => (Number(b.sort) || 0) - (Number(a.sort) || 0))
        .map(field => {
          const span = 24;
          const i18nKey = `register.${field.name}`;
          const label = this.$t(i18nKey);
          return {
            ...field,
            label: this.isEn ? label : field.label,
            span: span,
          };
        });
    },
    dynamicRules() {
      const rules = {};
      this.visibleFields.forEach(field => {
        const fieldRules = [];
        if (field.required) {
          fieldRules.push({ required: true, message: `请输入${field.label}`, trigger: 'blur' });
        }
        if (field.name === 'cellphone') {
          fieldRules.push({ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' });
        }
        if (field.name === 'email') {
          fieldRules.push({ pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/, message: '请输入正确的电子邮箱格式', trigger: 'blur' });
        }
        if (fieldRules.length > 0) {
          rules[field.name] = fieldRules;
        }
      });
      if (this.isEn) {
        rules['country'] = [
          { required: true, message: 'Please select country', trigger: 'change' }
        ];
      }
      return rules;
    }
  },
  created() {
    const savedLocale = localStorage.getItem('locale');
    if (savedLocale) {
      this.currentLocale = savedLocale;
    } else if (this.$i18n?.locale) {
      this.currentLocale = this.$i18n.locale;
    }

    eventBus.$on('event-ready', this.onEventReady);
    eventBus.$on('language-changed', (lang) => {
      this.currentLocale = lang;
      this.$nextTick(() => {
        if (this.$refs.basicForm) {
          this.$refs.basicForm.clearValidate();
        }
      });
    });

    if (this.$i18n && this.$i18n.on) {
      this.$i18n.on('languageChanged', (lang) => {
        this.currentLocale = lang;
        this.$nextTick(() => {
          if (this.$refs.basicForm) {
            this.$refs.basicForm.clearValidate();
          }
        });
      });
    }

    Promise.allSettled([
      this.fetchTicketList(),
      this.fetchEventSettings(),
      this.loadAllValidOrders(),
      this.fetchOrderConfig()
    ])
  },
  watch: {
    currentTicketCount: {
      handler(newVal) {
        this.updateGuests(newVal);
      },
      immediate: true,
    },
    userProfile: {
      handler(newVal) {
        if (newVal && this.guests.length > 0) {
          const mapping = {
            realname: 'realname',
            gender: 'gender',
            cellphone: 'cellphone',
            company: 'company',
            department: 'department',
            position: 'position',
            title: 'title',
            email: 'email',
          };
          Object.keys(mapping).forEach(key => {
            if (newVal[mapping[key]] !== undefined && !this.guests[0][key]) {
              this.$set(this.guests[0], key, newVal[mapping[key]]);
            }
          });
        }
      },
      immediate: true,
    },
    '$i18n.locale': {
      handler(newVal) {
        this.currentLocale = newVal;
        this.$nextTick(() => {
          if (this.$refs.basicForm) {
            this.$refs.basicForm.clearValidate();
          }
        });
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.$i18n && this.$i18n.off) {
      this.$i18n.off('languageChanged');
    }
    eventBus.$off('event-ready', this.onEventReady);
    eventBus.$off('language-changed');
  },
  methods: {
    formatTimestampToDateTime,

    /**
     * 跳转到报名表单页面
     */
    goToForm() {
      this.$router.replace('/register/form')
    },

    /**
     * 加载订单配置
     */
    async fetchOrderConfig() {
      try {
        const result = await getEventSettings(this.eventid);
        if (result.code !== 200) {
          this.orderConfig.enableInvoice = true;
          this.orderConfig.enableRefund = false;
          return;
        }
        
        const res = result.data;
        const rules = res?.rules || [];
        
        const invoiceRule = rules.find((item) => item.name === 'order_submit_invoice');
        if (invoiceRule !== undefined) {
          this.orderConfig.enableInvoice = !(invoiceRule?.value === false || invoiceRule?.value === 'false');
        } else {
          this.orderConfig.enableInvoice = true;
        }
        
        const refundRule = rules.find((item) => item.name === 'enable_refund_order');
        if (refundRule !== undefined) {
          this.orderConfig.enableRefund = refundRule?.value === true || refundRule?.value === 'true';
        } else {
          this.orderConfig.enableRefund = false;
        }
        
        console.log('订单配置:', this.orderConfig);
      } catch (error) {
        console.error('获取订单配置失败:', error);
        this.orderConfig.enableInvoice = true;
        this.orderConfig.enableRefund = false;
      }
    },

    /**
     * 加载所有有效订单
     */
    async loadAllValidOrders() {
      try {
        const meOrdersRes = await getMeOrders({
          filter: {
            validstatus: true,
            status: 0,
            type: 1
          }
        });
        
        if (meOrdersRes.code < 300 && meOrdersRes.data && meOrdersRes.data.list.length > 0) {
          const allOrders = meOrdersRes.data.list;
          const validOrders = allOrders.filter(order =>
            order.eventid === this.eventid && 
            order.type === 1 && 
            order.status >= 0 &&
            (order.paystatus > 98 || 
             (order.expiredat > Math.floor(Date.now() / 1000) && order.paystatus < 99))
          );
          
          this.validOrders = validOrders;
          console.log('orders:',validOrders);
          
          for (const order of validOrders) {
            await this.fetchOrderBadges(order.id);
          }
        } else {
          this.validOrders = [];
        }
        
        if (this.validOrders.length === 0 && !this.hasRedirected) {
          this.hasRedirected = true;
          this.goToForm();
        }
      } catch (error) {
        console.error('加载订单失败:', error);
        this.validOrders = [];
        if (!this.hasRedirected) {
          this.hasRedirected = true;
          this.goToForm();
        }
      }
    },

    /**
     * 获取指定订单的 badges
     */
    async fetchOrderBadges(orderId) {
      try {
        const res = await getOrderBadges(orderId);
        if (res.code < 300 && res.list && res.list.length > 0) {
          this.$set(this.orderBadgesMap, orderId, res.list);
        } else {
          this.$set(this.orderBadgesMap, orderId, []);
        }
      } catch (error) {
        console.error('获取订单徽章失败:', error);
        this.$set(this.orderBadgesMap, orderId, []);
      }
    },

    /**
     * 获取订单对应的 badges
     */
    getOrderBadges(orderId) {
      return this.orderBadgesMap[orderId] || [];
    },

    /**
     * 显示指定订单的支付弹窗
     */
    showPaymentPanelForOrder(order) {
      this.orderId = order.id;
      this.orderSubject = order.subject || '订单支付';
      this.orderAmount = order.amount || 0;
      this.showPaymentPanel = true;
    },

    handleStepMinus(ticket) {
      const minNum = ticket.minnum ?? 0;
      let val = this.ticketCountMap[ticket.id];
      if (val <= minNum) return;
      val--;
      this.$set(this.ticketCountMap, ticket.id, val);
      this.onCountChange(ticket);
    },
    handleStepPlus(ticket) {
      const maxNum = ticket.stock ?? 10;
      let val = this.ticketCountMap[ticket.id];
      if (val >= maxNum) return;
      val++;
      this.$set(this.ticketCountMap, ticket.id, val);
      this.onCountChange(ticket);
    },
    updateGuests(count) {
      const currentLength = this.guests.length;
      if (count > currentLength) {
        for (let i = currentLength; i < count; i++) {
          const guest = {};
          this.visibleFields.forEach(field => {
            this.$set(guest, field.name, '');
          });
          if (this.isEn) {
            this.$set(guest, 'country', '');
          }
          this.guests.push(guest);
        }
      } else if (count < currentLength) {
        this.guests.splice(count);
      }
    },
    onCountChange(ticket) {
      if (this.ticketCountMap[ticket.id] === 0) {
        if (this.selectedTicketId === ticket.id) {
          this.selectedTicketId = null;
        }
      } else {
        this.selectedTicketId = ticket.id;
      }
    },
    async fetchTicketList() {
      try {
        const res = await getEventTicketList(this.eventid);
        if (res.code < 300 && res.list && res.list.length > 0) {
          this.ticketList = res.list;
          this.ticketList.forEach(ticket => {
            if (this.ticketCountMap[ticket.id] === undefined) {
              this.$set(this.ticketCountMap, ticket.id, 0);
            }
          });
          if (this.ticketList.length > 0) {
            this.selectTicket(this.ticketList[0]);
          }
        }
      } catch (error) {
        console.error('获取票务列表失败:', error);
      }
    },
    selectTicket(ticket) {
      this.selectedTicketId = ticket.id;
      this.ticket = ticket;
      const minNum = ticket.minnum ?? 1;
      this.$set(this.ticketCountMap, ticket.id, minNum);
    },
    async fetchEventSettings() {
      try {
        const result = await getEventSettings(this.eventid);
        if (result.code < 300) {
          const res = result.data;
          const requiredList = res?.badgefields?.requires || [];
          const mergedFields = DEFAULT_FIELDS.map(defaultField => {
            const backendField = requiredList.find(item => item.name === defaultField.name);
            if (backendField) {
              return {
                ...defaultField,
                ...backendField,
                status: 1,
              };
            }
            if (defaultField.required) {
              return {
                ...defaultField,
                status: 1,
              };
            }
            return { ...defaultField, status: 0 };
          });

          this.fields = mergedFields;

          if (this.guests.length === 0) {
            const guest = {};
            this.fields.forEach(field => {
              this.$set(guest, field.name, '');
            });
            this.guests.push(guest);
          }
        }
      } catch (error) {
        console.error('获取事件设置失败:', error);
        this.fields = DEFAULT_FIELDS.map(f => ({ ...f, status: f.required ? 1 : 0 }));
        if (this.guests.length === 0) {
          const guest = {};
          this.fields.forEach(field => {
            this.$set(guest, field.name, '');
          });
          this.guests.push(guest);
        }
      }
    },
    submitForm() {
      let validAll = true;
      const formRefList = [];
      for (let i = 0; i < this.guests.length; i++) {
        const formRef = this.$refs['form_' + i];
        if (formRef && formRef[0]) {
          formRefList.push(formRef[0]);
          formRef[0].validate((valid) => {
            if (!valid) validAll = false;
          });
        }
      }

      if (!validAll) {
        this.$message.error('请完善所有报名人信息');
        return;
      }

      this.isSubmitting = true;
      this.createOrder()
        .then(async (orderId) => {
          this.orderId = orderId;
          const orderResult = await getOrder(orderId);
          const orderData = orderResult.data;
          this.orderSubject = orderData.subject || '订单支付';
          this.orderAmount = orderData.amount || 0;
          
          this.$message.success('报名信息校验完成，订单创建成功');
          this.showPaymentPanel = true;
        })
        .catch(err => {
          console.error('创建订单失败：', err);
          this.$message.error(err.message || '订单创建失败，请检查信息后重试');
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    resetForm() {
      this.guests.forEach((item, idx) => {
        const formRef = this.$refs['form_' + idx];
        if (formRef && formRef[0]) {
          formRef[0].resetFields();
        }
      });
      Object.keys(this.ticketCountMap).forEach(key => {
        this.$set(this.ticketCountMap, key, 0);
      });
      this.selectedTicketId = null;
    },
    onEventReady(eventData) {
      this.event = eventData;
      this.isLoading = false;
    },
    async createOrder() {
      try {
        const guests = this.guests.map(guest => {
          const processedGuest = { ...guest };
          
          if (processedGuest.gender !== undefined && processedGuest.gender !== null && processedGuest.gender !== '') {
            processedGuest.gender = Number(processedGuest.gender);
          } else {
            delete processedGuest.gender;
          }
          
          if (processedGuest.idtype !== undefined && processedGuest.idtype !== null && processedGuest.idtype !== '') {
            processedGuest.idtype = Number(processedGuest.idtype);
          } else {
            delete processedGuest.idtype;
          }
          
          return processedGuest;
        });
        
        const metas = { 'guests': guests };
        const params = {
          type: 1,
          cellphone: this.guests[0].cellphone,
          realname: this.guests[0].realname,
          title: this.guests[0].title,
          company: this.guests[0].company,
          email: this.guests[0].email,
          cartitems: [
            {
              goodid: this.ticket.id,
              goodnum: this.ticketCountMap[this.ticket.id],
              quantity: this.ticketCountMap[this.ticket.id],
              guests: guests,
            },
          ],
          metaitems: metas
        };
        console.log('params:', params);
        const orderRes = await postOrder(params);
        if (orderRes.code >= 300) {
          throw new Error(orderRes.msg || '创建订单失败');
        }
        return orderRes.data.id;
      } catch (error) {
        console.error('创建订单失败:', error);
        throw new Error(error.message || '创建订单失败，请稍后重试');
      }
    },
    handleBadgeQr(ebadgeId, dataUrl) {
      this.$set(this.badgeQrcodeMap, ebadgeId, dataUrl);
    },
    getCountryName(countryCode) {
      if (!countryCode) countryCode = 'CN';
      const target = this.countryOptions.find(item => item.value === countryCode);
      if (!target) return '中国';
      return this.isEn ? target.name_en : target.name_zh;
    },
    getOrderStatusText(order) {
      if (order.status == -90) return '已退款';
      if (order.paystatus > 98 || order.paystatus == 10) return '已完成';
      if (order.paystatus == 99) return '免费';
      if (order.status == -20) return '已过期';
      if (order.status == -50) return '已取消';
      if (order.paysource == 1) return '当面付';
      if (order.paysource == 4) return '银行转账';
      return '待支付';
    },
    getOrderStatusColor(order) {
      if (order.status == -90) return '#f56c6c';
      if (order.paystatus > 98 || order.paystatus == 10) return '#67c23a';
      if (order.paystatus == 99) return '#67c23a';
      if (order.status == -20) return '#e6a23c';
      if (order.status == -50) return '#f56c6c';
      if (order.paysource == 1) return '#409eff';
      if (order.paysource == 4) return '#67c23a';
      return '#f56c6c';
    },
    onPaymentSuccess(orderData) {
      console.log('支付成功:', orderData);
      this.loadAllValidOrders();
      this.$message.success('支付成功！');
    },
    onPaymentCancel() {
      console.log('用户取消了支付');
    },
    cancelOrder(order) {
      this.$confirm('确定要取消该订单吗？取消后订单将无法恢复。', '提示', {
        confirmButtonText: '确定取消',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await putOrderCancel(order.id);
          if (res.code < 300) {
            this.$message.success('订单取消成功');
            this.loadAllValidOrders();
          } else {
            this.$message.error(res.msg || '取消订单失败');
          }
        } catch (error) {
          console.error('取消订单失败:', error);
          this.$message.error('取消订单失败，请稍后重试');
        }
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    /**
     * 申请退款
     */
    applyRefund(order) {
      this.$confirm(
        this.$t('order.refund.confirmMessage', { amount: (order.amount / 100).toFixed(2) }), 
        this.$t('common.tip'), 
        {
          confirmButtonText: this.$t('order.refund.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      ).then(async () => {
        try {
          const res = await postOrderRefunds(order.id);
          if (res.code < 300) {
            this.$message.success('退款申请已提交，请等待审核');
            this.loadAllValidOrders();
          } else {
            this.$message.error(res.msg || '退款申请失败');
          }
        } catch (error) {
          console.error('申请退款失败:', error);
          this.$message.error('申请退款失败，请稍后重试');
        }
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    /**
     * 申请发票
     */
     applyInvoice(order) {
      this.invoiceOrderId = order.id
      this.invoiceOrderData = order
      this.invoiceOrderAmount = order.amount || 0
      this.invoiceMerchantId = order.merchantid || ''
      this.showInvoiceDialog = true
    },
    
    /**
     * 发票申请成功回调
     */
    onInvoiceSuccess(data) {
      console.log('发票申请成功:', data)
      this.$message.success('发票申请已提交，请等待处理')
      this.loadAllValidOrders()
    },

    /**
     * 获取问卷回执（可编辑）
     */
    async fetchSurveyResponse(orderId) {
      if (!orderId) {
        this.$message.warning('订单ID不存在');
        return;
      }
      
      this.surveyLoading = true;
      this.showSurveyDialog = true;
      this.surveyResponse = null;
      this.surveyQuestions = [];
      this.surveyForm = {};
      
      try {
        const res = await getSurveyResponse(this.eventid, orderId);
        console.log('获取问卷回执:', res);
        if (res.code === 200) {
          this.surveyResponse = res.data;
          this.surveyOrderId = orderId;
          this.surveySid = res.data.surveyid || '';
          
          if (this.surveySid) {
            const qRes = await getQuestions(this.surveySid);
            this.surveyQuestions = qRes.data?.list || [];
            console.log('问卷题目:', this.surveyQuestions);
            
            // 🔥 解析答案数据
            if (res.data.answers) {
              const answerKeys = Object.keys(res.data.answers);
              answerKeys.forEach(qid => {
                const answerData = res.data.answers[qid];
                if (answerData) {
                  // 找到对应的题目，获取题目类型
                  const question = this.surveyQuestions.find(q => q.id === qid);
                  let answerValue = '';
                  
                  if (question && question.type === 'radio') {
                    // 🔥 radio 类型：answer 对象中只有一个 key-value 对
                    // 例如: { A: "身份证" }
                    if (answerData.answer && typeof answerData.answer === 'object') {
                      const keys = Object.keys(answerData.answer);
                      if (keys.length > 0) {
                        // 返回的是选项值（key），用于回显 radio
                        answerValue = keys[0];
                      }
                    }
                  } else if (answerData.answer) {
                    // 其他类型：text, date, textarea 等
                    const ans = answerData.answer;
                    if (ans.text !== undefined && ans.text !== null && ans.text !== '') {
                      answerValue = ans.text;
                    } else if (ans.date !== undefined && ans.date !== null && ans.date !== '') {
                      answerValue = ans.date;
                    } else if (ans.label !== undefined && ans.label !== null && ans.label !== '') {
                      answerValue = ans.label;
                    } else if (ans.OTHER !== undefined && ans.OTHER !== null && ans.OTHER !== '') {
                      answerValue = ans.OTHER;
                    } else {
                      // 尝试获取第一个非空值
                      const values = Object.values(ans);
                      for (const val of values) {
                        if (val !== undefined && val !== null && val !== '') {
                          answerValue = val;
                          break;
                        }
                      }
                    }
                  }
                  
                  if (answerValue !== '' && answerValue !== undefined && answerValue !== null) {
                    this.$set(this.surveyForm, qid, answerValue);
                  }
                }
              });
              console.log('解析后的表单数据:', this.surveyForm);
            }
          }
        } else {
          this.$message.warning(res.msg || '暂无问卷回执');
          this.surveyResponse = null;
        }
      } catch (error) {
        console.error('获取问卷回执失败:', error);
        this.$message.error('获取问卷回执失败，请稍后重试');
        this.surveyResponse = null;
      } finally {
        this.surveyLoading = false;
      }
    },

    /**
     * 关闭问卷弹窗
     */
    closeSurveyDialog() {
      this.showSurveyDialog = false;
      this.surveyForm = {};
    },

    /**
     * 获取 placeholder
     */
    getPlaceholder(item) {
      const attr = item.attributes?.find(a => a.key === 'placeholder');
      return attr?.value || '';
    },

    /**
     * 提交问卷（保存所有修改）
     */
    async submitSurvey() {
      this.surveySubmitting = true;
      try {
        const promises = this.surveyQuestions.map(q => {
          const value = this.surveyForm[q.id];
          if (value !== undefined && value !== null && value !== '') {
            return this.submitAnswer(q, value);
          }
          return Promise.resolve();
        });
        
        await Promise.all(promises);
        
        if (this.surveySid && this.surveyOrderId) {
          await postSurveySubmit(this.surveySid, {
            refid: this.surveyOrderId,
            refobj: 'order',
            baseinfo: []
          });
        }
        
        this.$message.success('修改已保存');
        await this.fetchSurveyResponse(this.surveyOrderId);
      } catch (error) {
        console.error('保存问卷失败:', error);
        this.$message.error('保存问卷失败，请稍后重试');
      } finally {
        this.surveySubmitting = false;
      }
    },

    /**
     * 提交单个答案
     */
    async submitAnswer(question, value) {
      if (this.submittingQids.has(question.id)) return;
      this.submittingQids.add(question.id);
      
      try {
        let params = {};
        
        if (question.type === 'radio') {
          // 🔥 radio 提交格式: { answer: { "选项值": "选项标签" } }
          let realLabel = value;
          let realValue = value;
          if (Array.isArray(question.options)) {
            const opt = question.options.find(item => String(item.value) === String(value));
            if (opt) {
              realLabel = opt.label;
              realValue = opt.value;
            }
          }
          // 注意：这里的 key 是选项值，value 是选项标签
          params = { answer: { [realValue]: realLabel } };
        } else if (question.type === 'date') {
          params = { answer: { date: value } };
        } else if (question.type === 'number') {
          params = { answer: { text: String(value) } };
        } else if (question.type === 'textarea') {
          params = { answer: { text: String(value || '') } };
        } else {
          // 默认文本类型
          params = { answer: { text: String(value || '') } };
        }
        
        console.log('提交答案参数:', params);
        const res = await postAnswer(this.surveySid, question.id, params);
        if (res.code === 201) {
          this.surveyResponse.id = res.data.id;
          this.$message.success('信息已保存');
        } else {
          console.error('提交答案失败:', res);
        }
      } catch (error) {
        console.error('提交答案失败:', error);
      } finally {
        this.submittingQids.delete(question.id);
      }
    },

    /**
     * 单选提交（用于模板中的 @change）
     */
    async submitRadio(qid, value, other, memo, options) {
      if (this.submittingQids.has(qid)) return;
      this.submittingQids.add(qid);
      
      try {
        let realLabel = value;
        let realValue = value;
        if (Array.isArray(options)) {
          const opt = options.find(item => String(item.value) === String(value));
          if (opt) {
            realLabel = opt.label;
            realValue = opt.value;
          }
        }
        
        // 🔥 格式：{ answer: { "选项值": "选项标签" } }
        const params = other 
          ? { 'answer': { 'OTHER': memo } } 
          : { 'answer': { [realValue]: realLabel } };
        
        console.log('提交radio参数:', params);
        const res = await postAnswer(this.surveySid, qid, params);
        if (res.code === 201) {
          this.surveyResponse.id = res.data.id;
          this.$message.success('答案已保存');
        }
      } catch (error) {
        console.error('提交答案失败:', error);
      } finally {
        this.submittingQids.delete(qid);
      }
    },

    /**
     * 文本题目提交
     */
    async submitText(qid, value) {
      if (this.submittingQids.has(qid)) return;
      this.submittingQids.add(qid);
      
      try {
        const params = { answer: { text: String(value || '') } };
        const res = await postAnswer(this.surveySid, qid, params);
        if (res.code === 201) {
          this.surveyResponse.id = res.data.id;
        }
      } catch (error) {
        console.error('提交答案失败:', error);
      } finally {
        this.submittingQids.delete(qid);
      }
    },

    /**
     * 日期题目提交
     */
    async submitDate(qid, value) {
      if (this.submittingQids.has(qid)) return;
      this.submittingQids.add(qid);
      
      try {
        const params = { answer: { date: value } };
        const res = await postAnswer(this.surveySid, qid, params);
        if (res.code === 201) {
          this.surveyResponse.id = res.data.id;
        }
      } catch (error) {
        console.error('提交答案失败:', error);
      } finally {
        this.submittingQids.delete(qid);
      }
    },
  }
};
</script>

<style scoped>
.pc-padding {
  padding-left: 150px;
  padding-right: 150px;
}

@media (max-width: 768px) {
  .pc-padding {
    padding-left: 20px;
    padding-right: 20px;
  }
}

/* ===== 订单操作栏 ===== */
.order-actions-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f0fe 100%);
  border-radius: 12px;
  margin-bottom: 24px;
  border: 1px solid #c2d8f8;
}

.order-summary {
  display: flex;
  align-items: center;
  gap: 20px;
}

.order-count {
  font-size: 16px;
  font-weight: 600;
  color: #1a3a6b;
}

.order-total-badges {
  font-size: 14px;
  color: #666;
  background: #fff;
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid #d1e0f5;
  white-space: nowrap;
}

.order-section {
  margin-bottom: 30px;
}

.order-section:last-child {
  margin-bottom: 0;
}

.badge-count {
  font-size: 14px;
  color: #999;
  font-weight: 400;
  margin-left: 8px;
}

/* ===== 移动端适配 ===== */
@media (max-width: 768px) {
  .order-actions-bar {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 16px;
  }
  
  .order-summary {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px 12px;
    align-items: center;
    flex: 1;
  }
  
  .order-count {
    font-size: 14px;
  }
  
  .order-total-badges {
    font-size: 12px;
    padding: 2px 10px;
    white-space: nowrap;
  }
  
  .order-actions-bar .el-button {
    flex-shrink: 0;
    font-size: 13px;
    padding: 8px 14px;
  }
}

@media (max-width: 480px) {
  .order-actions-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .order-summary {
    justify-content: center;
  }
  
  .order-actions-bar .el-button {
    width: 100%;
    justify-content: center;
  }
}

/* ===== 订单信息卡片 ===== */
.order-info-card {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e8ecf1;
}

.order-status-row {
  display: flex;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f2f5;
}

.text-row {
  padding: 6px 0;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #f0f2f5;
}
.text-row:last-of-type {
  border-bottom: none;
}

.text-label {
  font-size: 13px;
  color: #999;
  line-height: 1.4;
}

.text-value {
  font-size: 15px;
  color: #1d2129;
  line-height: 1.5;
  word-break: break-all;
  font-weight: 500;
}

.pay-action-wrap {
  margin-top: 16px;
  padding-top: 16px;
}

.pay-action-wrap .btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.pay-action-wrap .btn-group .el-button {
  flex: 0 0 calc(50% - 5px);
  margin: 0;
}

@media (max-width: 768px) {
  .pay-action-wrap .btn-group .el-button {
    flex: 0 0 100%;
  }
}

/* ===== 票务列表外层 ===== */
.ticket-list-wrapper {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e8ecf1;
}

.ticket-list-header h4 {
  font-size: 20px;
  font-weight: 600;
  color: #1a3a6b;
  margin-bottom: 14px;
}

.ticket-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ticket-item {
  background: #ffffff;
  border-radius: 18px;
  padding: 15px;
  border: 2px solid #e6e8f0;
  cursor: pointer;
  transition: all 0.22s ease;
}
.ticket-item.ticket-active {
  border-color: #82b6ff;
  background-color: #ffffff;
}

.ticket-top-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.ticket-left-info {
  flex-shrink: 0;
}
.ticket-name {
  font-size: 16px;
  font-weight: 500;
  color: #111111;
  line-height: 1.2;
}
.ticket-price {
  font-size: 20px;
  font-weight: 600;
  color: #f25c5c;
  margin-top: 6px;
  line-height: 1.2;
}

.ticket-step-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}
.step-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s;
}
.step-minus {
  border: 2px solid #d1d1d1;
  color: #888;
  background: #fff;
}
.step-plus {
  background-color: #409EFF;
  color: #ffffff;
  border: 2px solid #409EFF;
}
.step-btn.btn-disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
.step-num {
  font-size: 18px;
  min-width: 18px;
  text-align: center;
  color: #111;
}

.ticket-divider {
  height: 1px;
  background: #e5e7eb;
  margin: 14px 0 14px;
}
.ticket-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  white-space: pre-line;
}

/* ===== 报名人表单样式 ===== */
.attendee-form-item {
  margin-bottom: 24px;
  padding: 20px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e8ecf1;
}

.attendee-form-item-first {
  margin-top: 0;
}

.attendee-form-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e8ecf1;
}

.attendee-form-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a3a6b;
}

.attendee-form-divider {
  flex: 1;
  margin-left: 12px;
}

.el-tag {
  color: #ffffff;
}

/* ===== 表单容器样式 ===== */
.form-wrapper {
  padding: 0 10px;
}

.form-title-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f4f8;
}
.form-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a3a6b;
  margin: 0;
}
.form-total-info {
  font-size: 16px;
  color: #333;
}

.form-actions {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f4f8;
}

/* ===== 电子门票卡片样式 ===== */
.ticket-card {
  position: relative;
  display: flex;
  align-items: stretch;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 20px;
}
.ticket-card:last-child {
  margin-bottom: 0;
}

.ticket-left {
  flex: 1;
  padding: 24px;
}
.ticket-row-two {
  display: flex;
  gap: 24px;
  margin-top: 12px;
}
.ticket-row-two:first-child {
  margin-top: 0;
}
.ticket-col {
  flex: 1;
}
.ticket-label {
  font-size: 13px;
  color: #86909c;
}
.ticket-value {
  font-size: 15px;
  color: #1d2129;
  line-height: 1.5;
  word-break: break-all;
}

.ticket-divider-notch {
  width: 16px;
  background-image: radial-gradient(circle 8px at 0px 8px, transparent 8px, #e4e7ed 8px);
  background-size: 16px 16px;
  background-repeat: repeat-y;
  background-position: left center;
}

.ticket-right {
  width: 180px;
  flex-shrink: 0;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f7f8fa;
}
.ticket-qrcode-img {
  width: 140px;
  height: 140px;
}
.qrcode-caption {
  margin-top: 10px;
  font-size: 13px;
  color: #6b7785;
}

.order-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.order-card-header .section-title {
  margin-bottom: 0;
}

.order-status-icon {
  width: 80px;
  height: auto;
  flex-shrink: 0;
}

/* ===== 支付面板样式 ===== */
.payment-container {
  text-align: center;
}
.payment-header {
  text-align: center;
  margin-bottom: 20px;
}
.price {
  font-size: 24px;
  font-weight: bold;
  color: #F56C6C;
  margin-top: 10px;
}
.payment-methods {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  display: flex;
  gap: 20px;
}
.payment-methods ::v-deep .el-radio {
  font-size: 16px;
}
.qrcode-section {
  text-align: center;
  padding: 10px 0;
}
.payment-qrcode {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.mt-5 {
  margin-top: 5px;
}
.mt-10 {
  margin-top: 10px;
}
.text-red {
  color: #F56C6C;
  font-size: 12px;
}
:deep(.el-dialog__body){
  padding: 0 20px 20px 20px;
}

/* ===== 问卷回执样式 ===== */
.survey-response-content {
  padding: 10px 0;
  max-height: 500px;
  overflow-y: auto;
}

.survey-header {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f4f8;
}

.survey-header h3 {
  font-size: 18px;
  color: #1a3a6b;
  margin: 0 0 8px 0;
}

.survey-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.survey-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.survey-item {
  padding: 16px 18px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e8ecf1;
}

.survey-item:hover {
  border-color: #c2d8f8;
}

.survey-question {
  font-size: 14px;
  font-weight: 600;
  color: #1a3a6b;
  margin-bottom: 8px;
}

.required-star {
  color: #f56c6c;
  margin-left: 4px;
}

.survey-answer {
  font-size: 14px;
  color: #333;
  padding-left: 4px;
}

.survey-answer .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
}

.survey-help {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.survey-footer {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e8ecf1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.survey-time {
  font-size: 13px;
  color: #999;
}

.survey-status {
  font-size: 13px;
  padding: 2px 12px;
  border-radius: 12px;
}

.status-submitted {
  background: #f0f9eb;
  color: #67c23a;
}

.status-draft {
  background: #fdf6ec;
  color: #e6a23c;
}

.survey-actions {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e8ecf1;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.survey-empty {
  padding: 30px 0;
}

/* 滚动条美化 */
.survey-response-content::-webkit-scrollbar {
  width: 6px;
}

.survey-response-content::-webkit-scrollbar-track {
  background: #f0f2f5;
  border-radius: 4px;
}

.survey-response-content::-webkit-scrollbar-thumb {
  background: #d0d5dd;
  border-radius: 4px;
}

.survey-response-content::-webkit-scrollbar-thumb:hover {
  background: #b0b8c4;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .pc-padding {
    padding-left: 20px;
    padding-right: 20px;
  }
  .ticket-list-wrapper {
    margin-bottom: 20px;
  }
  .form-wrapper {
    padding: 0;
  }
  .attendee-form-item {
    padding: 12px;
  }
  .ticket-step-wrapper {
    justify-content: flex-start;
  }
  .ticket-card {
    flex-direction: column;
  }
  .ticket-divider-notch {
    height: 16px;
    width: auto;
    background-image: radial-gradient(circle 8px at 8px 0, transparent 8px, #e4e7ed 8px);
    background-size: 16px 16px;
    background-repeat: repeat-x;
  }
  .ticket-right {
    width: 100%;
  }
  .ticket-row-two {
    flex-direction: column;
    gap: 8px;
  }
}
</style>